import { TMessage, TMessageSchema } from '../../types/messages';

export function mapMessageToDeleted(
  existingMessage: TMessage,
  { text, rowVersionV2, rowVersion, created }: TMessageSchema,
): TMessage {
  return {
    ...existingMessage,
    message: text || '',
    htmlText: null,
    files: null,
    offers: [],
    bubbles: null,
    actionButtons: null,
    actionButtonsV3: null,
    images: null,
    rowVersion: rowVersionV2 || rowVersion,
    created: new Date(created).getTime(),
    isRead: true,
    status: undefined,
    isDeleted: true,
    reply: null,
  };
}
